/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ComponentType } from 'react';

import { getProductCDNUrl, getMenuCDNUrl, getBrandCDNUrl } from 'modules/shared/utils';
import { SEO } from 'modules/shared/components';
import { CatalogueElement, Brand, Category, Product } from '../../models';

const GetParent = (element: Brand | Category | Product | any): string | undefined => {
    if (!element) {
        return undefined;
    }

    if ((element as Product).brand) {
        return (element as Product).brand.name;
    }

    if ((element as Category).parentCategory) {
        const { parentCategory } = element as Category;
        if (parentCategory) {
            return parentCategory.name;
        }
    }

    if ((element as Category).universe) {
        return (element as Category).universe.name;
    }

    return undefined;
};

const GetImage = (element: Brand | Category | Product | any): string | undefined => {
    if (!element) {
        return undefined;
    }

    if ((element as Product).images) {
        const { images } = element as Product;
        if (images.length > 0) {
            return getProductCDNUrl(images[0].thumbnailFileName);
        }
    }

    if ((element as Category).image) {
        const { image } = element as Category;
        return getMenuCDNUrl(image.thumbnailFileName);
    }

    if ((element as Brand).thumbnail) {
        return getBrandCDNUrl((element as Brand).thumbnail);
    }

    return undefined;
};

export const WithCatalogueSEO = <P extends {}>(catalogueElementFieldName: keyof P) => (
    Component: ComponentType<P>,
): React.FC<P> => {
    const WithSEOComponent: React.FC<P> = (props: P) => {
        const { [catalogueElementFieldName]: catalogueElement } = props;

        const castedCalatogueElement = (catalogueElement as unknown) as CatalogueElement;
        const { name, description } = castedCalatogueElement;

        const parentName = GetParent(catalogueElement);
        const pageTitle = `${name + (parentName ? ` - ${parentName}` : '')}, Catalogue`;
        const image = GetImage(catalogueElement);
        return (
            <React.Fragment>
                <SEO pageTitle={pageTitle} description={description} img={image} />
                <Component {...props} />
            </React.Fragment>
        );
    };

    return WithSEOComponent;
};
